module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst fieldConfig = model.config || {}\nconst isMultiSelect = !!fieldConfig.isMultiSelect\nconst {attributes = {}} = model.selectedEntity || {}\nconst selectedTitle = attributes.content || '-'\nconst nrOfElements = utils.collectionSize(model.dataJSON || {});\n%><div><%\nif(isMultiSelect){\n%><%= storage.__('prompt.form.picker.summary', { nrOfElements }); %><%\n} else {\n%><%= selectedTitle %><%\n}\n%></div>"
  , __filename = "components/templates/mblx/prompts/picker/selection.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const fieldConfig = model.config || {}
const isMultiSelect = !!fieldConfig.isMultiSelect
const {attributes = {}} = model.selectedEntity || {}
const selectedTitle = attributes.content || '-'
const nrOfElements = utils.collectionSize(model.dataJSON || {});

    ; __line = 7
    ; __append("<div>")
    ; 
if(isMultiSelect){

    ; __line = 9
    ; __append(escapeFn( storage.__('prompt.form.picker.summary', { nrOfElements }) ))
    ; 
} else {

    ; __line = 11
    ; __append(escapeFn( selectedTitle ))
    ; 
}

    ; __line = 13
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/mblx/prompts/picker/selection.ejs

}